import React from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

export const SearchSelect = props => {
  return (
    <Select
      isMulti={props.isMulti}
      components={animatedComponents}
      isClearable={props.isClearable}
      isSearchable={props.isSearchable}
      isDisabled={props.disabled}
      options={props.options}
      value={props.value}
      onChange={props.onChange}
      className={'basic-multi-select'}
      classNamePrefix="select"
      {...props}
      styles={{
        option: (base, { isFocused, isSelected }) => ({
          ...base,
          backgroundColor: isSelected ? 'white' : isFocused ? '#cce5ff' : '#ffffff',
          color: isSelected ? 'black' : 'black',
          '&:hover': {
            backgroundColor: '#b8daff',
          },
        }),
        input: (base, state) => ({
          ...base,
          fontSize: window.innerWidth <= 768 ? '16px' : '',
        }),
        control: (base, state) => ({
          ...base,
          border: '1px solid #dee2e6',
          boxShadow: state.isFocused ? '0 0 0 0.25rem #0d6efd40' : 'none',
          '&:hover': {
            border: '1px solid #b3b3b3',
          },
        }),
        dropdownIndicator: (baseStyles, state) => ({
          ...baseStyles,
          color: state.isFocused ? 'white' : '#6c757d',
          maxHeight: '38px',
          '&:hover': {
            color: 'white',
          },
        }),
        indicatorsContainer: (baseStyles, state) => ({
          ...baseStyles,
          backgroundColor: state.isFocused ? '#dee2e6' : '#eef2f7',
          borderTopRightRadius: '4px',
          borderBottomRightRadius: '4px',
          '&:hover': {
            backgroundColor: '#6c757d',
          },
        }),
        groupHeading: (base, state) => ({
          ...base,
          fontWeight: 'bold',
          fontSize: '14px',
          color: '#495057',
          backgroundColor: '#f8f9fa',
          padding: '4px 8px',
        }),
        group: (base, state) => ({
          ...base,
          padding: '4px 0',
        }),
        indicatorSeparator: (baseStyles, state) => ({
          ...baseStyles,
          margin: '0',
          backgroundColor: '#dee2e6',
        }),
        multiValue: (baseStyles, state) => ({
          ...baseStyles,
          color: '#6c757d',
          backgroundColor: '#eef2f7',
        }),
        valueContainer: (baseStyles, state) => ({
          ...baseStyles,
          flexWrap: 'nowrap',
        }),
        menu: baseStyles => ({
          ...baseStyles,
          maxHeight: props.maxHeight,
          overflow: 'hidden',
        }),
      }}
    />
  );
};
